var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaving(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C3.136 14 0 10.864 0 7C0 3.136 3.136 0 7 0C10.864 0 14 3.136 14 7C14 10.864 10.864 14 7 14ZM6.104 8.071L4.536 6.503C4.298 6.265 3.913 6.265 3.682 6.503C3.444 6.741 3.444 7.126 3.682 7.357L5.677 9.352C5.915 9.59 6.3 9.59 6.531 9.352L9.954 5.929C10.192 5.691 10.192 5.306 9.954 5.075C9.716 4.837 9.331 4.837 9.1 5.075L6.104 8.071Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    fill: "transparent",
    className: "path"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaving);
export default __webpack_public_path__ + "static/media/Saving.b0463c4c.svg";
export { ForwardRef as ReactComponent };